import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDWd-peuwZl2VoIEaVlRGctckn1n_GaAUI",
  authDomain: "polonsky-academy-bookings.firebaseapp.com",
  projectId: "polonsky-academy-bookings",
  storageBucket: "polonsky-academy-bookings.firebasestorage.app",
  messagingSenderId: "81100384103",
  appId: "1:81100384103:web:f167eb7d1c4544174431c2",
  measurementId: "G-7X40BL452P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
const analytics = getAnalytics(app);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export { db, analytics, auth };
